import { AxiosError } from 'axios';
import { put, call, takeLatest, select } from 'redux-saga/effects';
import { API } from '../api/base';
import { types, GetMediaRequest, GetMediaResponse } from './types';
import { getErrorMessage } from 'services/api/normalizer';
import { selectors as kioskSelectors } from 'services/kiosk';

export function* getMediaAsync({ payload }: GetMediaRequest) {
  yield put({ type: types.GET_MEDIA.PENDING, payload: true });

  try {
    const { id: kioskId } = yield select(kioskSelectors.selectKiosk);
    const api = new API(`kiosks/${kioskId}/media`);
    const response: GetMediaResponse = yield call(api.getAll, payload);
    yield put({ type: types.GET_MEDIA.SUCCESS, payload: response });
  } catch (err) {
    const message = getErrorMessage(err as AxiosError);
    yield put({ type: types.GET_MEDIA.ERROR, payload: message });
  } finally {
    yield put({ type: types.GET_MEDIA.PENDING, payload: false });
  }
}

export const sagas = [takeLatest(types.GET_MEDIA.REQUEST, getMediaAsync)];
